import isNil from 'lodash/isNil';
import React, {
  useEffect,
} from 'react';
import Select from 'core/components/Select';
import {
  Controller,
  useFormContext,
} from 'react-hook-form';
import range from 'lodash/range';

const validateValueIfPremature = (age: number, value: number) => (
  age < 19 ? !isNil(value) && value > 0 : true
);

const validateValueOfInches = (age: number, value: number) => (
  age < 19 ? !isNil(value) && value >= 0 : true
);

const heightInFeetOptions = range(1, 9);
const heightInInchesOptions = range(0, 12);
const inchesOptionsForMaxFeetValue = [0];

export default function HeightInput() {
  const { control, watch, setValue } = useFormContext();

  const [feet, age] = watch(['feet', 'age']);

  const validateFeet = (value: number) => validateValueIfPremature(age, value);
  const validateInches = (value: number) => validateValueOfInches(age, value);

  useEffect(() => {
    if (feet === 8) {
      setValue('inches', 0);
    }
  }, [feet]);

  return (
    <>
      <Controller
        name="feet"
        control={control}
        rules={{ validate: validateFeet }}
        render={({ field, fieldState: { error } }) => (
          <Select<number>
            {...field}
            id="feet-option"
            className="w-1/2"
            label="Height"
            placeholder="Feet"
            error={!isNil(error)}
            options={heightInFeetOptions}
            getLabel={(option: number) => option.toString()}
            getValue={(option: number) => option}
            showErrorText={false}
            renderValue={(val: string) => (
              <p>
                <span>{val}</span>
                {' '}
                {Number(val) > 0 ? 'Feet' : ''}
              </p>
            )}
          />
        )}
      />
      <Controller
        name="inches"
        control={control}
        rules={{ validate: validateInches }}
        render={({ field, fieldState: { error } }) => (
          <Select<number>
            {...field}
            id="inches-option"
            error={!isNil(error)}
            showErrorText={false}
            className="w-1/2"
            label=""
            placeholder="Inches"
            options={feet !== 8 ? heightInInchesOptions : inchesOptionsForMaxFeetValue}
            getLabel={(option: number) => option.toString()}
            getValue={(option: number) => option}
            renderValue={(val: string) => (
              <p>
                <span>{val}</span>
                {' '}
                Inches
              </p>
            )}
          />
        )}
      />
    </>
  );
}
